module.exports = __webpack_public_path__ + "img/syrian_arab_republic.41bd469.webp";